import React from 'react';
import { translate } from 'react-i18next';

import AssetsForm from 'components/assets/AssetsForm';
import * as Common from 'common/components';

const AssetsAdd = ({
  accounts,
  asset,
  catalogs,
  company,
  costCenters,
  depreciations,
  employees,
  files,
  handleFileAdd,
  handleFileRemove,
  handleSubmit,
  handleValidation,
  handleValueChange,
  isLoading,
  isSaving,
  isSubmitted,
  locations,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  projects,
  providers,
  subaccounts,
  subcompany,
  sublocations,
  asset_levels,
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <Common.Header title={t("assets.subtitle") + ">" + t("assets.title")} /> */}
      <div className="col-12">
        <Common.Portlet title={t('assets.title') + ' > ' + t('assets.add')} icon={'qrcode'}>
          <AssetsForm
            accounts={accounts}
            catalogs={catalogs}
            companyId={company.id}
            costCenters={costCenters}
            depreciations={depreciations}
            employees={employees}
            files={files}
            handleFileAdd={handleFileAdd}
            handleFileRemove={handleFileRemove}
            handleSubmit={handleSubmit}
            handleValidation={handleValidation}
            handleValueChange={handleValueChange}
            isLoading={isLoading}
            isSaving={isSaving}
            handleGroupChange={handleGroupChange} //Groups
            handleCustomFieldChange={handleCustomFieldChange} //Groups
            groups={groups} //Groups
            isSubmitted={isSubmitted}
            locations={locations}
            projects={projects}
            providers={providers}
            subaccounts={subaccounts}
            subcompanyId={subcompany.id}
            sublocations={sublocations}
            values={asset}
            asset_levels={asset_levels}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(AssetsAdd);



// WEBPACK FOOTER //
// src/components/assets/AssetsAddView.js